import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { deleteClaimCode } from '~/services/LuxLoyalty';

import { claimCampaignQueryKeys } from './claimCampaignQueryKeys';

interface DeleteClaimCodeParams {
  campaignId: string;
  codeId: string;
}

export function useDeleteClaimCode() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ campaignId, codeId }: DeleteClaimCodeParams) => {
      return await deleteClaimCode(campaignId, codeId);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: claimCampaignQueryKeys.codes(variables.campaignId) });
      enqueueSnackbar('Code deleted successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error deleting code: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
